import UserError from './UserError.js'

export class ParseBlockedUsersCookiesError extends UserError {
  #message

  /**
   * @param {string} message
   * */
  static create({message}) {
    return new ParseBlockedUsersCookiesError({message})
  }

  constructor({message}) {
    super()
    this.#message = message
  }

  get message() {
    return this.#message
  }

  toString() {
    return this.#message
  }
}
